export default "__VITE_ASSET__42c08ab7__"